import React, {useContext, useEffect} from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";
import {Form, InputNumber} from "antd";

const IngredientsPrice = ({responseIndex}) => {
    const [form] = Form.useForm()
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    useEffect(() => {
        if (recipeById.billOfMaterials[responseIndex].hasOwnProperty('stock')) {
            form.setFieldsValue({
                ingredientPrice: recipeById.billOfMaterials[responseIndex].unitPrice
            })
        }
    })

    const handlePriceChange = ({target}) => {
        let mockData = Object.assign({}, recipeById)
        mockData.billOfMaterials[responseIndex].unitPrice = target.value

        setRecipeById(mockData)
    }

    return (
        <React.Fragment>
            <Form
                form={form}
                wrapperCol={{span: 16}}
            >
                <Form.Item name={'ingredientPrice'}>
                    <InputNumber step={0.1} onBlur={handlePriceChange}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default IngredientsPrice